import { render, staticRenderFns } from "./profileForm.vue?vue&type=template&id=36e8014e"
import script from "./profileForm.vue?vue&type=script&lang=js"
export * from "./profileForm.vue?vue&type=script&lang=js"
import style0 from "./profileForm.vue?vue&type=style&index=0&id=36e8014e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports